import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MDBSysPrivacyPolicy from './pages/MDBSysPrivacyPolicy'; 

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MDBSysPrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default App;
